import { Component, OnInit } from '@angular/core';
import { ProductOperatingSystemService } from '../../../services/product-operating-system.service';
import { ProductService } from '../../../../products/services/product.service';


@Component({
  selector: 'app-list-product-operating-systems',
  templateUrl: './list-product-operating-systems.component.html',
  styleUrls: ['./list-product-operating-systems.component.css'],
  providers:[ProductOperatingSystemService,ProductService]
})
export class ListProductOperatingSystemsComponent implements OnInit {

  productOperatingSystems:any = [];

  constructor(private productOperatingSystemService:ProductOperatingSystemService, private productService:ProductService) { }

  ngOnInit() {
    this.getProductOperatingSystems();
  }

  getProductOperatingSystems(){
    this.productOperatingSystemService.query({})
      .subscribe((productOperatingSystems) => {
        this.productOperatingSystems = productOperatingSystems;
        this.parseProducts();
      });
  }

  parseProducts(){
    this.productOperatingSystems.forEach(function (productOperatingSystem){
      productOperatingSystem.productTypes = "";
      if(productOperatingSystem.product_types.includes("1")){
        productOperatingSystem.productTypes += "Móviles y Tablets,";
      }
      if(productOperatingSystem.product_types.includes("2")){
        productOperatingSystem.productTypes += "Consolas,";
      }
      if(productOperatingSystem.product_types.includes("3")){
        productOperatingSystem.productTypes += "Artículos Varios,";
      }
      if(productOperatingSystem.product_types.includes("4")){
        productOperatingSystem.productTypes += "PC's-portátiles,";
      }
      productOperatingSystem.productTypes = productOperatingSystem.productTypes.substring(0,productOperatingSystem.productTypes.length - 1);
    });
  }


  delete(productOperatingSystem){
    this.productService.query({so:productOperatingSystem.id})
    .subscribe((products) => {
      if (products.length > 0){
        alert("No se puede borrar debido ha que existen productos relacionados")
      }else{
        this.productOperatingSystemService.delete(productOperatingSystem.id)
        .subscribe((productOperatingSystem) => {
          this.getProductOperatingSystems()
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-operating-systems/list-product-operating-systems/list-product-operating-systems.component.ts